export class AnnouncementAccessResultDto {
    allowLocationAnnouncements: boolean;
    allowManagementCompanyAnnouncements: boolean;
    allowGlobalAnnouncements: boolean;

    get hasAccess(): boolean {
        return (
            this.allowGlobalAnnouncements || this.allowManagementCompanyAnnouncements || this.allowLocationAnnouncements
        );
    }
}
